import { useCallback, useRef } from "react";

export const useFocusInvalidField = () => {
  const fieldRef = useRef({});

  const focusFirstInvalidField = useCallback((errors, shouldScroll = true, order) => {
    let firstErrorField = Object.keys(errors)[0];
    if (order) {
      firstErrorField = order.find((key) => !!errors[key]);
    }

    if (firstErrorField && fieldRef?.current[firstErrorField]) {
      fieldRef.current[firstErrorField].focus();
      if (shouldScroll) {
        fieldRef.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, []);

  return { fieldRef, focusFirstInvalidField };
};
